import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const WorkflowFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [metrics, setMetrics] = useState([]);
  const [runType, setRunType] = useState([
    {
      value: 'anyTime',
      label: 'Bármikor'
    },
    {
      value: 'onSchedule',
      label: 'Beosztáskor'
    }
  ]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const technologyId = props.technologyId || window.App.urlVars().technologyId || window.App.urlVars().technology || formData?.technology?.id || formData?.technology;
    const payload = {
      ...data,
      ...newFormData,
    };
    if (technologyId && technologyId !== 'undefined') {
      payload.technology = technologyId;
    }
    if ((window.App.urlVars().workflowId) || (entity === 'workflow' && id)) {
      apiCall('patch', '/api/v2/workflow/' + (window.App.urlVars().workflowId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderWorkflowList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/workflow', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderWorkflowList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/workflow/workflow/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().workflowId) || (entity === 'workflow' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/workflow/' + (window.App.urlVars().workflowId ?? id))
        .then(response => {
          setFormData({ 
            ...response.data.data ,
            metrics: response.data.data.metrics?.id,
          });
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    apiCall('get', '/api/v2/metrics')
      .then(response => {
        setMetrics(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"workflow-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="run_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="run_type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRunType')}</label>
                  <span className="p-d-block">
                      <Dropdown id="run_type" {...input}
                                  options={window.App.sortDropdownOptions(runType, "label")}
                                  onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                      run_type: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      run_type: e.value
                                    })
                                  }}
                                  optionLabel="label"
                                  optionValue='value'
                                  value={formData.run_type}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="metrics" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="metrics"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMetrics')}</label>
                  <span className="p-d-block">
                      <Dropdown id="metrics" {...input}
                                  options={window.App.sortDropdownOptions(metrics, "name")}
                                  onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                      metrics: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      metrics: e.value
                                    })
                                  }}
                                  optionLabel="name"
                                  optionValue='id'
                                  value={formData.metrics}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'workflow' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(WorkflowFormComponent);
